import axios, { AxiosError, AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { PaginatedResponse } from "../models/pagination";

axios.defaults.baseURL = process.env.REACT_APP_BOOK_CATALOG_URL;
axios.defaults.headers.common['api-key'] = 'DA29C5D5-F179-43B2-8BEF-CFC46EFC41CF';

const responseBody = (response: AxiosResponse) => response.data;

axios.interceptors.response.use(async (response) => {
  const pagination = response.headers['pagination'];
  if (pagination) {
    response.data = new PaginatedResponse(response.data, JSON.parse(pagination));
  }

  return response;
}, (error: AxiosError) => {
  const { data, status } = error.response as any;
  switch (status) {
    case 400:
      if (data.errors) {
        const modelStateErrors: string[] = [];
        for (const key in data.errors) {
          if (data.errors[key]) {
            modelStateErrors.push(data.errors[key]);
          }
        }
        throw modelStateErrors.flat();
      }
      toast.error(data.title);
      break;
    case 401:
      toast.error(data.title);
      break;
    case 500:
      toast.error(data.title);
      break;
    default:
      break;
  }
  return Promise.reject(error.response);
})


const memoryCache: Record<string, any> = {};

const requests = {
  get: async (url: string, params?: URLSearchParams) => {
    const cacheKey = params ? `${url}?${params.toString()}` : url;

    if (memoryCache[cacheKey]) {
      return memoryCache[cacheKey];
    }

    const response = await axios.get(url, { params });
    const data = responseBody(response);
    memoryCache[cacheKey] = data;

    return data;
  },
};

const Catalog = {
  list: (params: URLSearchParams) => requests.get('v1/book-catalog', params),
  details: (id: number) => requests.get(`v1/book-catalog/${id}`),
  fetchFilters: () => requests.get('v1/book-catalog/filters'),
};

const agent = {
  Catalog,
};

export default agent;
